import { render } from "./BrandQuickRefUpload.vue?vue&type=template&id=ca959dd2"
import script from "./BrandQuickRefUpload.vue?vue&type=script&lang=js"
export * from "./BrandQuickRefUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__